import React from 'react';
import { Globe, Users, Rocket } from 'lucide-react';

// Team values data
const VALUES = [
    {
        icon: <Globe className="w-8 h-8 text-blue-400" />,
        title: "Global Perspective",
        description: "Based in Sydney, serving clients worldwide with comprehensive data solutions that respect regional needs."
    },
    {
        icon: <Users className="w-8 h-8 text-purple-400" />,
        title: "Client-Centric",
        description: "Your success is our priority. We work closely with you to understand and meet your unique business challenges."
    },
    {
        icon: <Rocket className="w-8 h-8 text-green-400" />,
        title: "Innovation",
        description: "Constantly evolving our approaches to stay ahead in the fast-paced world of data analytics and artificial intelligence."
    }
];

export default VALUES;